module.exports = __webpack_public_path__ + "img/witness47b5311.47b53116.png";